import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isText())?_c(VCard,{staticClass:"pa-3",attrs:{"id":"tos","flat":"","tile":""},domProps:{"innerHTML":_vm._s(_vm.tosText)}}):_c(VCol,{class:_vm.$style.tosPdf},[_c('object',{attrs:{"data":_vm.tosPdf,"type":"application/pdf","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }